import React, { useEffect } from 'react';

const WorkflowLogs = () => {
  React.useEffect(() => {
    // eslint-disable-next-line no-console
    console.warn('Placeholder: WorkflowLogs is not implemented yet.');
  }, []);
  return (
    <>
  { /*WorkflowLogs */} 
 </>
  );
};

export default WorkflowLogs;
